import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function Login() {
  const nav = useNavigate();
  const { signIn, refreshProfile } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(email, password);
      const data = await refreshProfile();
      const role = data?.user?.profile?.role;
      const business = data?.business;
      toast.success('Welcome back');
      if (role === 'customer') nav('/my', { replace: true });
      else if (role === 'super_admin') nav('/admin', { replace: true });
      else if (role === 'merchant_owner' || role === 'merchant_manager') nav(business ? '/app' : '/onboarding', { replace: true });
      else nav('/onboarding', { replace: true });
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  const inputCls = 'w-full bg-white border border-gray-200 rounded-xl px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-rozops-blue/20 focus:border-rozops-blue transition-all';

  return (
    <div className="min-h-screen bg-rozops-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8">
          <img src="/ro-hlogo.png" alt="RozOps" className="h-16 w-auto object-contain" />
        </Link>
        <div className="bg-white rounded-3xl border border-gray-100 shadow-soft p-8">
          <h1 className="font-heading font-bold text-2xl text-rozops-navy">Welcome back</h1>
          <p className="text-sm text-rozops-text-muted mt-1">Log in to your RozOps account</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-semibold text-rozops-text mb-1.5">Email</label>
              <input type="email" required data-testid="login-email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-rozops-text mb-1.5">Password</label>
              <input type="password" required data-testid="login-password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button type="submit" disabled={busy} data-testid="login-submit" className="w-full bg-rozops-blue hover:bg-rozops-blue-dark text-white rounded-xl px-4 py-3 font-semibold shadow-soft hover:shadow-medium transition-all disabled:opacity-50 inline-flex items-center justify-center gap-2">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Log in
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-rozops-text-muted">
            No account? <Link to="/register" className="text-rozops-blue font-semibold">Start Free</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
